import { ICompany } from 'app/shared/model/company.model';
import { IInspectionItem } from 'app/shared/model/inspection-item.model';
import { IInspectionHistory } from 'app/shared/model/inspection-history.model';
import { InspectionTypes } from 'app/shared/model/enumerations/inspection-types.model';

export interface IInspection {
  id?: number;
  name?: string | null;
  description?: string | null;
  type?: InspectionTypes | null;
  company?: ICompany | null;
  inspectionItems?: IInspectionItem[] | null;
  inspectionHistories?: IInspectionHistory[] | null;
  observations?: string | null;
}

export const defaultValue: Readonly<IInspection> = {};
